module.exports = __webpack_public_path__ + "media/images/rio-claro-logo-colorida-2-f6ffa009.svg";